import { Injectable } from '@angular/core';
import { ReceiptPrinterModule } from './components/ReceiptPrinterModule.service';
import { BillAcceptorStatus } from './components/billacceptor.service';


@Injectable({
    providedIn: 'root'
})
export class MockSignalRService {
    hubConnection(url: string) {
        let connection = new HubConnection(url)
        return connection
    }
}

class HubConnection {
    connection: string = ''
    simulate = {
        connection_error: false,
    }

    constructor(connection: string) {
        this.connection = connection;
    }
    createHubProxy(name: string) {
        let kiosk = new Kiosk;
        let proxy = new HubProxy(name, kiosk)
        kiosk.setProxy(proxy)
        return proxy
    }

    start(): Promise<any | void> {
        return new Promise((resolve, reject) => {
            this.simulate.connection_error ? reject() : resolve(true)
        })
    }
}

export class HubProxy {
    name: string = '';
    kiosk: any;
    id: string = ''
    listeners: any[] = []
    constructor(name: string, kiosk: Kiosk) {
        this.name = name;
        this.kiosk = kiosk;
        this.id = sessionStorage.getItem('id') || Math.round(Math.random() * 10 ** 16).toString(16);
        sessionStorage.setItem('id', this.id)
        
        /*
        const fblisteners = doc(db, 'listeners', this.id);
        setDoc(fblisteners, { id: this.id })
        const unsubscribe = onSnapshot(
            collection(db, "ls"),
            (snapshot) => {
                // ...
                snapshot.docs.filter(sn => sn.id == this.id).map(sn => {
                    if (sn.exists()) {
                        let data: any = sn.data();
                        this.trigger.call(this, data.method, data.payload)
                        deleteDoc(doc(db, "ls", this.id))
                    }
                })
            },
            (error) => {
                // ...
            });
        */


        let listeners = JSON.parse(localStorage.getItem('listeners') || '[]');
        localStorage.setItem('listeners', JSON.stringify([...listeners.filter((listener: string) => listener != this.id), this.id]))
        window.addEventListener('close', () => {
            localStorage.setItem('listeners', JSON.stringify([...listeners.filter((listener: string) => listener != this.id)]))
        })
        window.addEventListener('storage', (e) => {
            if (e.key == this.id && e.newValue) {
                let data = JSON.parse(e.newValue)
                this.trigger.call(this, data.method, data.payload)
                localStorage.removeItem(this.id)
            }
        })
    }

    on(event: string, handler: (_?: any) => void) {
        this.listeners.push({ event, handler })
    }

    once(event: string, handler: (_?: any) => void) {
        let _cb = (evt: any) => {
            handler.call(this, evt)
            this.off(event, _cb)
        }
        this.listeners.push({ event, handler: _cb })
    }

    off(event: string, handler: (_?: any) => void) {
        this.listeners = this.listeners.filter((listener: any) => {
            return !(listener.event.toLowerCase() == event.toLowerCase() && (!handler || listener.handler.toString() == handler.toString()))
        })
    }

    invoke(method: string, ...parameters: any) {
        // console.log('called', method, 'with', parameters)
        return new Promise((resolve, reject) => {
            if (this.kiosk[method]) {
                let result = this.kiosk[method].call(this.kiosk, ...parameters)
                resolve(result)
            } else {
                let component = this.kiosk.components.find((component: any) => component[method])
                if (component) {
                    let result = component[method].call(component, ...[component.CompIdx, component.DeviceManagerInterface, ...parameters])
                    resolve(result)
                }
            }
            reject()
        })
    }

    trigger(event: string, payload?: any) {
        this.listeners.filter((listener: any) => {
            return listener.event.toLowerCase() == event.toLowerCase()
        }).map((listener: any) => {
            listener.handler(payload)
        })
    }

    simulate(method: string, payload: any) {
        let listeners = JSON.parse(localStorage.getItem('listeners') || '[]');

        listeners.filter((listener: string) => listener != this.id).map((listener: string) => {
            localStorage.setItem(listener, JSON.stringify({ method, payload }))
        })
        // this.simulatorFirebase(method, payload)
    }

    // async simulatorFirebase(method: string, payload: any) {
    //     const docRef = query(collection(db, "listeners"))
    //     const querySnapshot = await getDocs(docRef);
    //     querySnapshot.forEach((docSnap) => {
    //         // doc.data() is never undefined for query doc snapshots
    //         if (docSnap.exists()) {
    //             let id = (<{ id: string }>docSnap.data()).id
    //             if (id != this.id) {
    //                 const evt = doc(db, 'ls', id)
    //                 setDoc(evt, { method, payload })
    //             }
    //         } else {
    //             // docSnap.data() will be undefined in this case
    //             console.log("No such document!");
    //         }
    //     });
    // }
}

interface InputStatus {
    IOPoint: number;
    InputResponse: any;
}
interface IOPoint {
    IOPoint: number;
    InputDevice: string;
    OutputDevice: string;
}

class Kiosk {
    components: any[] = []
    proxy: HubProxy | undefined;

    constructor() {
        this.components = [
            new IoModule(this),
            new ApplicationModule(this),
            new CPUModule(this),
            new BillAcceptor(this),
            new BillDispenser(this),
            new BarcodeScanner(this),
            new PinPad(this),
            new ReceiptPrinter(this),
        ]
    }

    setProxy(proxy: HubProxy) {
        this.proxy = proxy;
        this.proxy?.on('syncLS', ({ Payload }) => {
            localStorage.setItem('metadata', JSON.stringify(Payload))
        })
    }

    getAllComponents() {
        return this.components.map((component) => {
            return { CompIdx: component.CompIdx, DeviceManagerInterface: component.DeviceManagerInterface, ComponentTypeName: component.ComponentTypeName }
        })
    }
}
class IoModule {
    io = {};
    CompIdx = 1;
    DeviceManagerInterface = 1
    ComponentTypeName = 'IO_Module'
    kiosk;

    constructor(kiosk: Kiosk) {
        this.kiosk = kiosk;
    }

    get metadata() {
        return JSON.parse(localStorage.getItem('metadata') || '{}') || {}
    }

    set metadata(value) {
        localStorage.setItem('metadata', JSON.stringify(value))
        this.kiosk.proxy?.simulate('syncLS', { Payload: value })
    }

    // OnIOModuleResponse_Event
    IOModule_Connect(idx: number, ComponentModelName: string): void {
        this.kiosk.proxy?.trigger('OnIOModuleConnected_Event')
        // OnIOModuleConnected_Event
        // OnIOModuleConnectedError_Event
    }

    IOModule_Disconnect(idx: number, ComponentModelName: string): void {
        // OnIOModuleDisconnected_Event
        // OnIOModuleDisconnectedError_Event
    }

    IOModule_GetInputDeviceStatus(idx: number, ComponentModelName: string): InputStatus[] {
        return []
    }

    IOModule_GetItems(idx: number, ComponentModelName: string): IOPoint[] {
        return []
    }

    IOModule_IsConnected(idx: number, ComponentModelName: string): boolean {
        return this.metadata?.io.connected;
    }

    IOModule_TurnOffOutputDevice(idx: number, ComponentModelName: string, IOPoint: number): void {


    }

    IOModule_TurnOnOutputDevice(idx: number, ComponentModelName: string, IOPoint: number): void {

    }

}


class CPUModule {
    CompIdx = 2;
    DeviceManagerInterface = 2
    ComponentTypeName = 'CPU'
    kiosk;

    constructor(kiosk: Kiosk) {
        this.kiosk = kiosk;
    }

    get metadata() {
        return JSON.parse(localStorage.getItem('metadata') || '{}') ?? {}
    }

    set metadata(value) {
        localStorage.setItem('metadata', JSON.stringify(value))
        this.kiosk.proxy?.simulate('syncLS', { Payload: value })
    }

    CPU_GetComputerData() {
        return this.metadata?.data || {
            ComputerName: "TESTKIOSK001",
            KioskName: "TESTKIOSK001",
            KioskNameUnitName: "TESTKIOSK001",
            LocationID: "TESTKIOSK001",
            UnitName: "TESTKIOSK001",
        }
    }

    // unofficial
    CPU_SetComputerData(idx: number, ComponentModelName: string, data: {
        ComputerName: string,
        KioskName: string,
        KioskNameUnitName: string,
        LocationID: string,
        UnitName: string,
    }) {
        this.metadata = { ...this.metadata, data };
    }
}

class ApplicationModule {
    CompIdx = 3;
    DeviceManagerInterface = "Application.Engage.AppDictionary"
    ComponentTypeName = 'Application'
    kiosk;

    constructor(kiosk: Kiosk) {
        this.kiosk = kiosk;
    }

    get metadata() {
        return JSON.parse(localStorage.getItem('metadata') || '{}') ?? {}
    }

    set metadata(value) {
        localStorage.setItem('metadata', JSON.stringify(value))
        this.kiosk.proxy?.simulate('syncLS', { Payload: value })
    }

    Application_GetDictionary(idx: number, ComponentModelName: string) {
        return this.metadata?.dictionary || {
            password: 'TESTKIOSK001'
        }
    }

    // unofficial
    Application_SetDictionary(idx: number, ComponentModelName: string, data: any) {
        this.metadata = { ...this.metadata, dictionary: data }
    }

}

class BillAcceptor {
    CompIdx = 4;
    DeviceManagerInterface = 4
    ComponentTypeName = 'Bill_Acceptor'
    status = {
        Connected: false,
        IsAcceptingBills: false,
        Count: 0,
        IsEscrow: false,
        IsCassettePresent: false,
        IsStackerFull: false,
        IsBillJammed: false,
        IsBusy: false,
        IsDeviceFailed: false
    }
    kiosk;

    constructor(kiosk: Kiosk) {
        this.kiosk = kiosk;
    }

    get metadata() {
        return JSON.parse(localStorage.getItem('metadata') || '{}') || {}
    }

    set metadata(value) {
        localStorage.setItem('metadata', JSON.stringify(value))
        this.kiosk.proxy?.simulate('syncLS', { Payload: value })
    }

    billAcceptor_Connect() {
        this.metadata = { ...this.metadata, bill_acceptor: { ...(this.metadata.bill_acceptor || this.status), Connected: true } }
    }

    BillAcceptor_GetDeviceStatus(): BillAcceptorStatus {
        return this.metadata.bill_acceptor
    }

    billAcceptor_EnableAcceptance() {
        this.metadata = { ...this.metadata, bill_acceptor: { ...(this.metadata.bill_acceptor || this.status), IsAcceptingBills: true } }
    }

    billAcceptor_DisableAcceptance() {

    }

    setOpenCloseAcceptor() {

    }
}
class BillDispenser {
    CompIdx = 5;
    DeviceManagerInterface = 5
    ComponentTypeName = 'Bill_Dispenser'
    kiosk;

    constructor(kiosk: Kiosk) {
        this.kiosk = kiosk;
    }
    billDispenser_Connect() {

    }

}
class BarcodeScanner {
    CompIdx = 6;
    DeviceManagerInterface = 6
    ComponentTypeName = 'Barcode_Scanner'
    kiosk;

    constructor(kiosk: Kiosk) {
        this.kiosk = kiosk;
    }

    barcodeScanner_Connect() {

    }
}
class PinPad {
    CompIdx = 7;
    DeviceManagerInterface = 7
    ComponentTypeName = 'PinPad'
    kiosk;

    constructor(kiosk: Kiosk) {
        this.kiosk = kiosk;
    }

    pinPad_Connect() {

    }
}

type SerialPrinter = "ReceiptPrinter.GenMega.RPU";
type HtmlPrinter =
    "ReceiptPrinter.Custom.VKP80II" |
    "ReceiptPrinter.Custom.VKP80IIETH" |
    "ReceiptPrinter.Custom.VKP80III" |
    "ReceiptPrinter.Custom.TG02H" |
    "ReceiptPrinter.Custom.KPM216E2" |
    "ReceiptPrinter.Epson.TMSeries" |
    "ReceiptPrinter.Pyramid.Reliance" |
    "ReceiptPrinter.Generic.Any"
class ReceiptPrinter {
    CompIdx = 8;
    DeviceManagerInterface: SerialPrinter | HtmlPrinter = 'ReceiptPrinter.Generic.Any';
    ComponentTypeName = 'Receipt_Printer';
    kiosk;

    constructor(kiosk: Kiosk) {
        this.kiosk = kiosk;
    }

    receiptPrinter_PrintReceiptHtml(idx: number, ComponentModelName: string, content: string): boolean {
        (async () => {
            await ReceiptPrinterModule.printToURL(content, true)
        })()
        this.kiosk.proxy?.trigger('OnReceiptPrinterPrinted_Event')
        return true
    }

    receiptPrinter_PrintDocument(idx: number, ComponentModelName: string, content: { Items: any[] }): boolean {
        (async () => {
            await ReceiptPrinterModule.printToURL(content)
        })()
        this.kiosk.proxy?.trigger('OnReceiptPrinterPrinted_Event')
        return true
    }

    receiptPrinter_SaveReceiptData(idx: number, ComponentModelName: string, name: string, orderId: string, dateTime: number, orderTotal: number, receiptText: string): void {

    }

    ReceiptPrinter_GetStatus(idx: number, ComponentModelName: string): string[] {
        return [];
    }

    /**
     * 
     * @decription Enables printer monitoring if the Enable parameter is set to true; otherwise, monitoring stops. By default, the printer will be monitoring; therefore, this method DOES NOT need to be called in your application if you want to enable printer monitoring
     */
    ReceiptPrinter_EnableMonitoring(idx: number, ComponentModelName: string, enable: boolean): void {

    }
}